const setTeachersClass = () => {
  // При количестве преподавателей меньше 4 блоку добавляется класс для стилизации
  const teachersContainer = document.querySelector('.teachers');
  if (!teachersContainer) return;
  const teachers = teachersContainer.querySelectorAll('.teachers__item');

  teachersContainer.classList.add('teachers--alt');
};
 
export default setTeachersClass;
 